import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";

const DeleteLoadingButton = ({
  title,
  handleClick,
  isLoading,
  isSaved,
  isDisabled,
}) => {
  return (
    <LoadingButton
      color={"error"}
      disabled={isDisabled}
      size="small"
      onClick={() => handleClick()}
      loading={isLoading}
      loadingPosition="start"
      variant="outlined"
      startIcon={isSaved ? <DoneRoundedIcon /> : <DeleteIcon />}
    >
      <span>{title || "Delete"}</span>
    </LoadingButton>
  );
};

export default DeleteLoadingButton;
